<ng-container>
  <app-virtual-keyboard
      (keyPress)="onKeyboardInput($event)"
      *ngIf="kioskMode"
  >
  </app-virtual-keyboard>
    <div style="background:{{pageConfig?.background}}; height: 100vh; width: 100vw; zoom: 1; position: absolute;
            transform: translate({{pageConfig?.x}}px, {{pageConfig?.y}}px) scale({{pageConfig?.scaleX}}, {{pageConfig?.scaleY}});
            -webkit-transform: translate({{pageConfig?.x}}px, {{pageConfig?.y}}px) scale({{pageConfig?.scale}});
        "></div>
    <div style="background: #FFFFFF; width: 100vw; height: 100vh; left: 0; top: 0; position: absolute; z-index: -1">
    </div>
    <div
        *ngIf="blockScreen"
        class="loading_overlay"
    >
        <ion-spinner
            class="loading_overlay_spinner"
        >
        </ion-spinner>
    </div>
    <ion-content style="--background: transparent">
        <ion-grid style="text-align: center; padding: 0">

            <!-- test for debugging -->
            <button *ngIf="configCheckerEnabled && isElectron && !checkerDataService.isCheckerActive" (click)="openCheckerSettings()">Open Checker</button>

            <ng-container *ngFor="let m of elementConfig | keyvalue; index as i; trackBy: trackByKey">
                <ng-container
                        *ngIf="!(['logo'].includes(m.value.elementType))  && helperFunctions?.checkElement(m.key)"
                >
                    <button
                        *ngIf="m.value.elementType === 'button'"
                        [class]="m.value.class"
                        [ngStyle]="m.value.css"
                        (pointerup)="helperFunctions?.executeStage(m.value.goTo ?? 'DO_NOT_GO_TO_ANY_PAGE', 'click')"
                        (keyup.enter)="helperFunctions?.executeStage(m.value.goTo ?? 'DO_NOT_GO_TO_ANY_PAGE', 'click')"
                    >
                        {{m.value.maintitle | translate: languageStore}}
                    </button>

                    <button
                        *ngIf="m.value.elementType === 'functionButton'"
                        [class]="m.value.class"
                        [ngStyle]="m.value.css"
                        (click)="helperFunctions?.handleFunction(m.value.handleFunction);"
                        (keyup.enter)="helperFunctions?.executeStage(m.value.goTo, 'click')"
                        [disabled]="!m.value.handleFunction?.name"
                    >
                        {{m.value.maintitle | translate: languageStore}}
                    </button>


                    <ion-checkbox
                        *ngIf="m.value.elementType === 'checkbox' && m.value?.handleFunction?.ignoreClick"
                        [class]="m.value.class"
                        [checked]="helperFunctions?.getKeyValWrapper(m.value)"
                        [ngStyle]="m.value.css"
                        style="pointer-events: none"
                    ></ion-checkbox>

                    <ion-checkbox
                        *ngIf="m.value.elementType === 'checkbox' && !(m.value?.handleFunction?.ignoreClick)"
                        [class]="m.value.class"
                        [checked]="helperFunctions?.getKeyValWrapper(m.value)"
                        [ngStyle]="m.value.css"
                        (ionChange)="helperFunctions?.handleFunction(m.value.handleFunction)"
                    ></ion-checkbox>

                    <input
                        appVirtualKeyboard
                        [id]="m.key"
                        *ngIf="m.value.elementType === 'input'"
                        [placeholder]="helperFunctions?.getKeyValParser(m.value) | translate: languageStore"
                        [type]="m.value.handleFunction?.elementType ?? 'string'"
                        class="{{m.value.class}}{{m.value.focus ? ' focus' : ''}}"
                        [value]="helperFunctions?.getKeyValWrapper(m.value) ?? ''"
                        [ngStyle]="m.value.css"
                        (change)="helperFunctions?.handleFunction(m.value.handleFunction, $event.target.value)"
                        (keyup.enter)="m.value.goTo ? helperFunctions?.executeStage(m.value.goTo, 'pressedEnter') : focusNextVirtualKeyboardInput()"
                    />

                    <textarea
                        *ngIf="m.value.elementType === 'comment'"
                        [placeholder]="m.value.maintitle | translate: languageStore"
                        class="{{m.value.class}}{{m.value.focus ? ' focus' : ''}}"
                        [value]="helperFunctions?.getKeyValWrapper(m.value) ?? ''"
                        [ngStyle]="m.value.css"
                        (change)="helperFunctions?.handleFunction(m.value.handleFunction, $event.target.value)"
                        (keyup.enter)="helperFunctions?.handleFunction(m.value.handleFunction, $event.target.value)"
                      ></textarea>

                    <input
                        *ngIf="m.value.elementType === 'barcode'"
                        class="barcode {{m.value.class}}"
                        [value]="helperFunctions?.getKeyValWrapper(m.value) ?? ''"
                        [ngStyle]="m.value.css"
                        (change)="helperFunctions?.handleFunction(m.value.handleFunction, $event.target.value)"
                        (keyup.enter)="helperFunctions?.executeStage(m.value.goTo, 'scannedBarcode')"
                        type="text"
                        inputmode="none"
                        autofocus="autofocus"
                    />

                    <select
                        [ngStyle]="m.value.css"
                        [class]="m.value.class"
                        *ngIf="m.value.elementType === 'options'"
                        (change)="helperFunctions?.handleFunction(m.value.handleFunction, $event.target.value, m.value.goTo, m.value.handleFunction.argument.replace(' ', '').split(','))"
                    >
                        <option value="" disabled selected>{{m.value.handleFunction.placeholder | translate: languageStore}}</option>
                        <option
                            *ngFor="let option of m.value.handleFunction.argument.replace(' ', '').split(',')"
                            [selected]="(option) === helperFunctions?.getKeyValWrapper(m.value)"
                        >
                            {{option | translate: languageStore}}
                        </option>
                    </select>


                    <ng-container
                        class="content"
                        *ngIf="m.value.elementType === 'breather'"
                    >
                        <app-breathing-animation
                            name="crescent"
                            [class]="m.value.class"
                            [ngStyle]="m.value.css"
                            [breatheInText]="'MEASUREMENT_HEART_BREATH_IN' | translate: languageStore"
                            [breatheOutText]="'MEASUREMENT_HEART_BREATH_OUT' | translate: languageStore"
                        ></app-breathing-animation>
                    </ng-container>


                    <ng-container
                        class="content"
                        *ngIf="m.value.elementType === 'spinner'"
                    >
                        <ion-spinner
                            name="crescent"
                            [class]="m.value.class"
                            [ngStyle]="m.value.css"
                        ></ion-spinner>
                    </ng-container>

                    <ng-container *ngIf="m.value.elementType === 'note'" class="ion-text-center">
                        <div
                            [class]="m.value.class"
                            [ngStyle]="m.value.css"
                            [innerHTML]="(helperFunctions?.getKeyValWrapper(m.value) ?? (m.value.maintitle)) | translate: languageStore"
                        >
                        </div>
                    </ng-container>

                    <ng-container *ngIf="m.value.elementType === 'h2'" class="ion-text-center">
                        <div
                            [class]="m.value.class"
                            [ngStyle]="m.value.css"
                            [innerHTML]="(helperFunctions?.getKeyValWrapper(m.value) ?? (m.value.maintitle)) | translate: languageStore"
                        >
                        </div>
                    </ng-container>

                    <ng-container *ngIf="m.value.elementType === 'p'" class="ion-text-center">
                        <div
                            [class]="m.value.class"
                            [ngStyle]="m.value.css"
                            [innerHTML]="(helperFunctions?.getKeyValWrapper(m.value) ?? (m.value.maintitle)) | translate: languageStore"
                        >
                        </div>
                    </ng-container>

                    <ng-container *ngIf="m.value.elementType === 'valueMappedColor'" class="ion-text-center">
                        <div
                            [class]="m.value.class"
                            [ngStyle]="m.value.css"
                            [innerHTML]="(helperFunctions?.getKeyValWrapper(m.value) ?? m.value.maintitle) | translate: languageStore"
                        >
                        </div>
                    </ng-container>

                    <ng-container *ngIf="m.value.elementType === 'animatedNumber'" class="ion-text-center">
                        <app-animated-number
                            [class]="m.value.class"
                            [ngStyle]="m.value.css"
                            [value]="(helperFunctions?.getKeyValWrapper(m.value) ?? m.value.maintitle) | translate: languageStore"
                            [options]="m.value.numberAnimation"
                            [animationKey]="m.value"
                        ></app-animated-number>
                    </ng-container>

                    <ng-container *ngIf="m.value.elementType === 'scrollText'" class="ion-text-center">
                        <div
                            class="scroll-text {{m.value.class || ''}}"
                            [class.scroll-text--show-hint]="shouldShowScrollTextHint(scrollTextContent)"
                            [ngStyle]="m.value.css"
                        >
                            <div
                                #scrollTextContent
                                class="scroll-text__content"
                                (scroll)="onScrollTextScroll()"
                                [innerHTML]="(helperFunctions?.getKeyValWrapper(m.value) ?? (m.value.maintitle)) | translate: languageStore"
                            >
                            </div>
                            <div
                                *ngIf="shouldShowScrollTextHint(scrollTextContent)"
                                class="scroll-text__indicator"
                                aria-hidden="true"
                            ></div>
                        </div>
                    </ng-container>


                    <ng-container
                        class="content"
                        *ngIf="m.value.elementType === 'resource'"
                    >
                        <object
                            [class]="m.value.class"
                            [ngStyle]="m.value.css"
                        ></object>
                    </ng-container>


                    <ng-container
                        class="content"
                        *ngIf="m.value.elementType === 'slider'"
                    >
                        <div
                            [class]="m.value.class"
                            [ngStyle]="m.value.css"
                        >
                            <object
                                [ngStyle]="m.value.cssInner"
                            ></object>
                        </div>
                    </ng-container>


                    <ng-container
                            class="content"
                            *ngIf="m.value.elementType === 'video'"
                    >
                        <video
                            [class]="m.value.class"
                            [loop]="m.value.background.loop === false ? false : true"
                            autoplay
                            [muted]="m.value.background?.muted === false ? false : true"
                            playsinline
                            webkit-playsinline
                            poster="assets/imgs/transparent.png"
                            [ngStyle]="m.value.css"
                            (play)="m.value.background.loop === false ? videoFinished = false : null;"
                            (ended)="videoFinished = true;"
                        >
                            <source
                                [src]="m.value.resource | safe"
                                type="video/mp4"
                            >
                        </video>
                    </ng-container>

                    <ng-container *ngIf="m.value.elementType === 'link'">
                        <p
                            [class]="m.value.class"
                            [ngStyle]="m.value.css"
                            (click)="helperFunctions?.openLink(m.value.url)"
                        >
                            {{m.value.maintitle | translate: languageStore}}
                        </p>
                    </ng-container>

                    <ng-container *ngIf="m.value.elementType === 'qrCode'">
                        <div
                            [class]="m.value.class"
                            [ngStyle]="m.value.css"
                        >
                            <qrcode
                                [qrdata]="helperFunctions?.getKeyValWrapper(m.value) ?? ''"
                                [width]="genQrSize(m.value.css)"
                                [colorDark]="m.value.css.qrColor ?? '#000000'"
                                [colorLight]="m.value.css.qrBackgroundColor ?? '#FFFFFF'"
                                [margin]="m.value.css.qrMargin ?? 4"
                                [errorCorrectionLevel]="'L'"
                            >
                            </qrcode>
                        </div>
                    </ng-container>

                    <ion-col
                        *ngIf="m.value.elementType === 'progressBar'"
                        [class]="m.value.class"
                    >
                        <ng-container *ngIf="barIsMeasured[m.value.index]">
                            <ion-progress-bar [ngStyle]="m.value.css" [value]="helperFunctions?.getProgress(m.value.index)"></ion-progress-bar>
                        </ng-container>
                        <ng-container *ngIf="!barIsMeasured[m.value.index]">
                            <ion-progress-bar class="progress-semi" [ngStyle]="m.value.css" [value]="helperFunctions?.getProgress(m.value.index)"></ion-progress-bar>
                        </ng-container>
                    </ion-col>

                    <ion-col
                        *ngIf="m.value.elementType === 'progressBarHrv'"
                        [class]="m.value.class"
                    >
                        <ng-container *ngIf="hrvBarIsMeasured">
                            <ion-progress-bar [ngStyle]="m.value.css" [value]="hrvProgress"></ion-progress-bar>
                        </ng-container>
                        <ng-container *ngIf="!hrvBarIsMeasured">
                            <ion-progress-bar class="progress-semi" [ngStyle]="m.value.css" [value]="hrvProgress"></ion-progress-bar>
                        </ng-container>
                    </ion-col>



                    <ng-container *ngIf="m.value.elementType === 'json'">
                        <app-json-viewer
                            [json]="getKeyVal(m.value?.handleFunction?.group + '.' + m.value?.handleFunction?.value, state)"
                            [jwt]="state.persistentValues.JWT"
                            [setBlockScreen]="helperFunctions?.setBlockScreen"
                            [ngStyle]="m.value.css"
                        ></app-json-viewer>
                    </ng-container>

                    <ng-container *ngIf="m.value.elementType === 'file'">
                        <input
                            id="upload-file"
                            type="file"
                            (change)="m.value.goTo ? helperFunctions?.executeStage(m.value.goTo, 'fileSelected') : undefined"
                            [ngStyle]="m.value.css"
                        >
                    </ng-container>


                    <ng-container *ngIf="m.value.elementType === 'iframe' || m.value.elementType === 'iframePost'">
                        <iframe sandbox="
                        allow-forms
                        allow-modals
                        allow-pointer-lock
                        allow-popups
                        allow-popups-to-escape-sandbox
                        allow-same-origin
                        allow-scripts
                        allow-top-navigation
                        "
                            allowfullscreen
                            [ngStyle]="m.value.css"
                            [class]="m.value.class"
                            [src]="m.value.elementType === 'iframePost' ? 'about:blank' : m.value.trustedResourceUrl"
                            name="iFrame"
                        >
                        </iframe>
                        <ng-container *ngIf="m.value.elementType === 'iframePost'">
                            <form ngNoForm id="postIframe" target="iFrame" [action]="m.value.design" method="post">
                                <input type="hidden" name="values" [value]="helperFunctions?.getSendState()">
                            </form>
                        </ng-container>
                    </ng-container>

                </ng-container>
            </ng-container>
            <ion-row>
                <ion-col>
                    <div class="footer"></div>
                </ion-col>
            </ion-row>
        </ion-grid>
    </ion-content>
    <div *ngIf="state?.persistentValues?.DEMO_MODE" class="demo-mode-info absolute">{{"DEMO MODE" | translate: languageStore}}</div>
</ng-container>
